<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Is your chronic kidney disease (CKD) stage 3 (eGFR 30 – 59) or 4 (eGFR &lt; 30)? <br />
      What was you most recent creatinine level?
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isCKDInStage3Or4">
      <b-form-radio v-model="survey.medicalConditions.chronicKidneyDisease.isCKDInStage3Or4" name="ckd"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.medicalConditions.chronicKidneyDisease.isCKDInStage3Or4" name="ckd"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
    <v-form-group class="page-buttons" v-if="isCKDInStage3Or4" :validator="$v.creatinineLevel" label="Creatinine level">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.medicalConditions.chronicKidneyDisease.creatinineLevel"
                    placeholder="Creatinine" />
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, decimal, between, requiredIf } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      isCKDInStage3Or4: {
        required
      },
      creatinineLevel: {
        required: requiredIf(function () { return this.isCKDInStage3Or4; }),
        decimal,
        between: between(0.5, 25.0)
      }
    },

    computed: {
      ...mapState(["survey"]),

      isCKDInStage3Or4() { return this.survey.medicalConditions.chronicKidneyDisease.isCKDInStage3Or4; },
      creatinineLevel() { return this.survey.medicalConditions.chronicKidneyDisease.creatinineLevel; }
    }
  };
</script>